/**
 * WordPress dependencies
 */
import { getContext, store, useEffect, getElement } from '@wordpress/interactivity';

// Interactivy store for the Inline Gallery block.
const { state, callbacks } = store('itp/inline-gallery', {
  actions: {
    initGallerySlide() {
      const index = getContext()?.index;
      const url = new URL(window.location);
      const slideIndex = Number(url.searchParams.get('inlineSlide'));

      if (index !== slideIndex) {
        return;
      }

      const { ref } = getElement();
      ref.scrollIntoView({
        behavior: 'instant',
      });
    },
    next() {
      if (state.selectedIndex === state.totalSlides) return;
      state.selectedIndex++;
      callbacks.updateUrl();
    },
    prev() {
      if (state.selectedIndex === 1) return;
      state.selectedIndex--;
      callbacks.updateUrl();
    },
    touch() {
      localStorage.setItem('displaySwipe', true);
      state.displaySwipe = false;
    },
  },
  callbacks: {
    displaySwipe() {
      const displaySwipe = localStorage.getItem('displaySwipe');
      if (displaySwipe) return;
      state.displaySwipe = true;
    },
    initSlideObserver() {
      /* eslint-disable react-hooks/rules-of-hooks */
      useEffect(() => {
        const ctx = getContext();
        if (ctx.observer) return;
        const { ref } = getElement();

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                state.selectedIndex = ctx?.index;
                callbacks.updateUrl();
              }
            });
          },
          {
            rootMargin: '0px',
            threshold: 0.6,
          },
        );
        ctx.observer = observer;
        observer.observe(ref);
      });
    },
    isActiveIndex() {
      const context = getContext();

      if (state.selectedIndex === context.index) {
        context.isHidden = false;
        state.isCurated = context.isCurated;
      } else {
        context.isHidden = true;
      }
    },
    isPrevBlocked() {
      if (state.selectedIndex === 1) {
        state.prevBlocked = true;
      } else {
        state.prevBlocked = false;
      }
    },
    isNextBlocked() {
      if (state.selectedIndex === state.totalSlides) {
        state.nextBlocked = true;
      } else {
        state.nextBlocked = false;
      }
    },
    updateUrl() {
      const url = new URL(window.location);
      url.searchParams.set('inlineSlide', state.selectedIndex);
      url.hash = 'inline-gallery';
      window.history.replaceState({}, '', url.toString());
    },
  },
});
